import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { isEmpty, orderBy, uniqBy, get } from 'lodash';
import { useSelector } from 'react-redux';
import { getTabsSelector } from 'store/global/selectors';
import { getIsGetUserInfoLoading } from 'store/user/selectors';
import { CircularProgress } from '@material-ui/core';
import { GlobalLoadingWrapper } from 'helpers/routing/styles';

const PublicRoute = ({ component: Component, roles, ...rest }: any) => {
  const tabs = useSelector(getTabsSelector);
  const tabsValues = uniqBy(orderBy(tabs, 'position'), 'type');
  const isLoading = useSelector(getIsGetUserInfoLoading);
  const firstUniversPathName = get(tabsValues, '[0].path');

  return (
    <Route
      {...rest}
      render={(props) =>
        isLoading ? (
          <GlobalLoadingWrapper>
            <CircularProgress data-testid="loader" size={50} />
          </GlobalLoadingWrapper>
        ) : !isEmpty(firstUniversPathName) ? (
          <Redirect
            to={{
              pathname: firstUniversPathName,
              state: { from: props.location },
            }}
          />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

export default PublicRoute;
